module.exports = "/_next/static/images/1fac4d35518250843efb2baeba606961-logo-exame-investe.png.webp";